// extracted by mini-css-extract-plugin
export default {"editorContainer":"rkimfEzsxfu45J39NATogw=="};